export const AI_SEARCH_API_BASE_URL =
  'https://fajs3dykpm.us-east-1.awsapprunner.com/plat-ai-search/global';

export const FORUM_IAH_SALES_URL = 'https://editoraforum.com.br/forum-iah';
